import { inject, NewInstance } from 'aurelia-framework';
import { StandardService } from 'pages/standard-setup/standards/service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { DialogController, DialogService } from 'aurelia-dialog';
import { ValidationRules, ValidationController, validateTrigger } from 'aurelia-validation';
import { BootstrapFormRenderer } from 'resources/validation-renderer';
import toastr from 'toastr';

@inject(DialogController, DialogService, NewInstance.of(ValidationController), StandardService, EventAggregator)
export class StandardConfigEditor {
    constructor(controller, dialogService, validationController, standardService, ea) {
        this.controller = controller;
        this.dialogService = dialogService;
        this.standardService = standardService;
        this.ea = ea;
        this.standard = {
            groups: [],
            workCenter: 'STAMPING',
        };

        this.validationController = validationController;
        this.validationController.validateTrigger = validateTrigger.manual;
        this.validationController.addRenderer(new BootstrapFormRenderer());
        this.rules = ValidationRules
            .ensure('workCenter').required()
            .rules;
    }

    async activate(model) {
        this.standardNumberId = model?.standardNumberId;
        if (model?.id != null) {
            this.standard = await this.standardService.getConfigById(model.standardNumberId, model.id);
        }
    }

    addGroup () {
        this.standard.groups.push({
            items: [],
            processId: null,
            machineId: null,
            opened: true
        });
    }

    async save() {
        if (this.isRequesting) return;
        this.isRequesting = true;
        const validationResult = await this.validationController.validate();
        if (validationResult.valid) {
            try {
                if (this.standard.id) {
                    await this.standardService.updateConfig(this.standardNumberId, this.standard);
                    toastr.success('Standard was updated!');
                } else {
                    await this.standardService.createConfig(this.standardNumberId, this.standard);
                    toastr.success('New standard was created!');
                }
                this.ea.publish('standard-config:updated', this.standard);
                this.controller.ok(this.standard);
            } catch {
                this.isRequesting = false;
            }
        }
        this.isRequesting = false;
    }
}
